// @ts-nocheck
import { chunk, throttle } from 'lodash';
import { PresenceStatus } from '../models/enums';
import BaseService from './BaseService';

export const MAX_USERS_PER_REQUEST = 50;
export const THROTTLE_TIME = 500;
export const POLL_INTERVAL = 60000;

export default class PresenceService extends BaseService {
  mounted() {
    this._data = {};
    this._userIds = new Set();
    this.throttledFetch = throttle(this.fetchPresenceData, THROTTLE_TIME, { leading: false });
    this.timeoutId = setTimeout(this.throttledFetch, POLL_INTERVAL);
  }

  dispose() {
    this._data = null;
    this._userIds = null;
    clearTimeout(this.timeoutId);
  }

  fetchPresenceData = async () => {
    clearTimeout(this.timeoutId);
    if (!this._userIds.size) return;
    const idGroups = chunk(Array.from(this._userIds.values()), MAX_USERS_PER_REQUEST);
    try {
      for (const idGroup of idGroups) {
        const response: {
          result: {
            userId: string;
            presenceStatus: string;
          }[];
        } = await this.host.api.presence.findMulti({ userIds: idGroup });
        response.result.forEach(({ userId, presenceStatus }) => {
          this.set(userId, PresenceStatus.resolve(presenceStatus));
        });
      }
    } finally {
      this.timeoutId = setTimeout(this.throttledFetch, POLL_INTERVAL);
    }
  };

  addUser(userid) {
    this._userIds.add(userid);
    this.throttledFetch();
  }

  removeUser(userid) {
    this._userIds.delete(userid);
    delete this._data[userid];
  }

  set(id, presenceStatus) {
    const hasChanged = this._data[id] !== presenceStatus;
    if (!hasChanged) return;

    this._data[id] = presenceStatus;
    const user = this.host.models.User.inject({ id, presenceStatus });

    this.emit('change', {
      presenceStatus,
      user,
      userId: id,
    });
  }

  get(id) {
    if (id === this.host.currentUserId) return PresenceStatus.AVAILABLE;

    return this._data[id] || PresenceStatus.UNKNOWN;
  }
}
